import { Component } from 'react';
import { Page, Card, Spinner } from '@shopify/polaris';
import {
  reqGetCannyPlugInSSO,
  reqGetFeedback
} from '../../../api';
import utils from '../../../utils/utils';

import Feedback from './components/CannyFun';
import SkeltonLoading from '../../../components/SkeltonLoading';
import {
  withRouter
} from 'react-router-dom';
import './index.css';

import Language from '../../../i18n/Language';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
const t = Language;
class indexClass extends Component {
  state = {
    ssoToken: '',
    //弹窗
    showToast: false,  //弹窗显示
    showToastText: '',  //弹窗文字
    showToastIserror: false, //弹窗是否错误
    isShowStatus: false,
    inDevelopment: '', // 更新进度
    newFunctions: [],  // 新功能
  };

  // 获取ssoToken
  getCannyPlugInSSO = async () => {
    // try {
    const res = await reqGetCannyPlugInSSO();
    if (res.code === 200) {
      this.setState({
        ssoToken: res.data.ssoToken,
      })
    } else {
      this.setState({
        ssoToken: '',
      }, () => {
        this.props.toggleToast(res.msg, true);
      })
    }
    // } catch (error) {
    // this.props.toggleToast('ssoToken error', true);
    // }
  }

  // 获取feedback列表
  // getFeedbackList = async () => {
  //   const res = await reqGetFeedback();
  //   if (res.ack === 1) {
  //     var richText = res.data.new_functions;
  //     richText = richText.replace(/&lt;p&gt;/g, "<p>").replace(/&lt;\/p&gt;/g, "</p>");
  //     richText = richText.replace(/&lt;a\s+href=(['"])(.*?)\1/g, '<a href="$2">');
  //     let funcHTML = richText.split('\n').map(item => {
  //       return {
  //         text: item.split('"')[2].slice(1, item.split('"')[2].indexOf('</a>')),
  //         url: item.split('"')[1].slice(2)
  //       }
  //     })

  //     this.setState({
  //       inDevelopment: res.data.in_development,
  //       newFunctions: funcHTML,
  //     })
  //   } else {
  //     this.props.toggleToast(res.msg, true);
  //   }
  // }

  getFeedbackList = async () => {
    const res = await reqGetFeedback();
    if (res.ack === 1) {
      let richText = res.data.new_functions;
      let parser = new DOMParser();
      let doc = parser.parseFromString(richText, 'text/html');
      let nodeList = doc.body.childNodes;
      let newFuncList = [];
      for (let i = 0; i < nodeList.length; i++) {
        let node = nodeList[i];
        if (node.nodeType === Node.ELEMENT_NODE) {
          let son = node.childNodes[0];
          newFuncList[i] = {
            id: i + 1,
            title: son.innerText || '',
            url: son.pathname || '/dashboard',
            desc: son.title ? son.title.split('==')[0] : '',
            date: son.title ? son.title.split('==')[1] : '',
          }
        } else {
          newFuncList[i] = false;
        }
      }
      this.setState({
        FBLoading: false,
        newFuncList: newFuncList.filter(i => Boolean(i)),
      })
    } else {
      this.props.toggleToast(res.msg, true);
    }
  }

  sendBackStatus = () => {
    this.setState({
      isShowStatus: true
    })
  }

  // 返回
  goBack = () => {
    utils.routeJump(this, '/dashboard')
  }

  componentDidMount() {
    this.getCannyPlugInSSO();
    // this.getFeedbackList();
  }

  render() {
    // 底部
    const FooterHelpBox = <FooterTrustHelp />

    // 最终内容
    var pageContentLast = !Boolean(this.state.ssoToken) ? <SkeltonLoading /> :
      <Page
        title={t("Feature Request")}
        backAction={{
          content: t("Feature Request"),
          onAction: this.goBack,
        }}
      >
        <title>SEOAnt - Feature Request</title>
        {/* <Layout> */}
        {/* <Layout.Section>
            <Layout>
              <Layout.Section variant='oneThird'>
                <Card>
                  <BlockStack gap={400}>
                    <Text variant="headingMd" as="h2">{t("In development")}</Text>
                    <div className='development_functions_height'>
                      <div className='devs_text' dangerouslySetInnerHTML={{ __html: this.state.inDevelopment }}></div>
                    </div>
                  </BlockStack>
                </Card>
              </Layout.Section>
              <Layout.Section variant='oneThird'>
                <Card>
                  <BlockStack gap={400}>
                    <Text variant="headingMd" as="h2">{t("New functions")}</Text>
                    <div className='development_functions_height'>
                      <div id='hiddenHtmlBlock'></div>
                      {this.state.newFunctions.map(item => {
                        return <p key={item.text}><span role="img" aria-label="emoji">👉👉👉</span> <Link onClick={() => {
                          utils.routeJump(this, item.url)
                        }}>{item.text}</Link></p>
                      })}
                    </div>
                  </BlockStack>
                </Card>
              </Layout.Section>
            </Layout>
          </Layout.Section> */}
        {/* <Layout.Section>
            <Layout>
              <Layout.Section variant='oneHalf'>
                
              </Layout.Section>
            </Layout>
          </Layout.Section>
        </Layout> */}
        <Card>
          {
            Boolean(this.state.ssoToken) ? <div className={`Feedback`} style={{ display: Boolean(this.state.isShowStatus) ? 'block' : 'none' }}>
              <Feedback ssoToken={this.state.ssoToken} sendBackStatus={() => this.sendBackStatus()} />
            </div> : null
          }
          {/* {
                    Boolean(this.state.ssoToken) ?
                      <div className='Feedback' style={{ display: Boolean(this.state.isShowStatus) ? 'block' : 'none' }}>
                        <Feedback ssoToken={this.state.ssoToken} sendBackStatus={() => this.sendBackStatus()} />
                      </div>
                      : null
                  } */}
          <div style={{ display: Boolean(this.state.isShowStatus) ? 'none' : 'block' }}><div className="DetailReport_Empty_New_div_margin_800">
            <Spinner size="large" color="teal" />
          </div></div>
        </Card>
        {/* 底部 */}
        {FooterHelpBox}
      </Page>

    return (
      <div>
        {pageContentLast}
      </div>
    );
  }
}

export default withRouter(indexClass);
